import React, { FunctionComponent } from 'react'
import { Link, Text } from '@afterpaytouch/core'
import { Trans } from 'next-i18next'

import { AssetChildComponentSpacing, MarginSize } from './types'
import { getSpacingClassName } from './helper'

interface Props extends AssetChildComponentSpacing {
  label?: string
  privacyUrl?: string
  show?: boolean
  testNameSpace?: string
}

export const FinePrint: FunctionComponent<Props> = ({
  show = true,
  label = '',
  privacyUrl = '',
  testNameSpace = '',
  margin,
  marginTop = MarginSize.x2,
  marginBottom,
}) => {
  if (!label || !show) {
    return null
  }

  return (
    <div className={getSpacingClassName({ margin, marginTop, marginBottom })}>
      <Text size='XXS' color='Gray40' renderAs='div' testNameSpace={`finePrint-${testNameSpace}`} fontFace='CashSansMono'>
        <Trans
          i18nKey={label}
          components={{
            privacy: <Link key='postcheckout-privacy-link' target='_blank' kind='Underline' href={privacyUrl} />,
          }}
        />
      </Text>
    </div>
  )
}
